/**
 * dbtfy-visualization-status.js
 *
 * Shows the "working on your visualization" banner exactly once, right
 * after a customer lands on /cart from the "Изпрати за визуализация"
 * button (flag set by dbtfy-send-for-visualization.js). On any other
 * cart visit, the banner stays hidden — we don't want to nag returning
 * visitors who are just checking their cart days later.
 *
 * The flag is intentionally NOT cleared immediately on show — it stays
 * until the customer navigates away from /cart, so a page refresh while
 * still reviewing their cart doesn't make the banner flicker away.
 */
(function () {
  "use strict";

  var STATUS_FLAG_KEY = "dbtfy_visualization_in_progress";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function isOnCartPage() {
    return /\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search) ||
      window.location.pathname === "/cart";
  }

  ready(function () {
    if (!isOnCartPage()) return;

    var flag;
    try {
      flag = sessionStorage.getItem(STATUS_FLAG_KEY);
    } catch (e) {
      flag = null;
    }

    if (!flag) return;

    var banner = document.querySelector("[data-dbtfy-viz-status]");
    if (banner) banner.hidden = false;
  });

  // Clear the flag once the customer leaves the cart page (e.g. heading
  // to checkout, or browsing to another product). This way the banner
  // only ever shows for the visit immediately following a submission.
  window.addEventListener("beforeunload", function () {
    if (!isOnCartPage()) return;
    try {
      sessionStorage.removeItem(STATUS_FLAG_KEY);
    } catch (e) {
      // ignore
    }
  });
})();
